module.exports = __webpack_public_path__ + "static/media/logo.1b6a7526.svg";